<template>
  <div id="app">
    <div class="mainAlert">
      <el-alert v-if="wrongBrowser"
                title="Ваш браузер не поддерживется."
                type="warning"/>
    </div>
    <!--<formIndex></formIndex>-->
    <router-view />
  </div>
</template>
<script>
  import {isIE, isEdge} from '@/functions/browsers'
// import formIndex from "@/views/form/index";
export default {
    name:'App',
    computed:{
        wrongBrowser(){
            if (isIE || isEdge){
                return true
            }
            // let ua = navigator.userAgent;
            // let a = navigator.appCodeName;
            // console.log(a)
            // console.log(ua)
            // console.log(ua.indexOf(/MSIE/))
            // console.log(ua.search(/MSIE/))
            //
            // console.log(ua.indexOf(/rv/))
            // console.log(ua.search(/rv/))
            // if (ua.indexOf(/MSIE/) > -1 || ua.indexOf(/rv/) > -1 ){
            //     return true
            // }
        }
    },
  // data() {
  //   return {};
  // },
  // components: {
  //   formIndex
  // }
};
</script>
<style lang="scss">
body {
  margin: 0;
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
}
#app {
  color: #2c3e50;
  height: 100%;
}
.mainAlert{
  .el-alert{
    background-color: #f4c32b;
    color: #808080;
    display: block;
    text-align: center;
    .el-alert__content{
      display: inline-block;
    }
  }
  margin-bottom: 10px;
}
</style>

